var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-sidebar',{attrs:{"active":_vm.$store.state.sidebars.showReceiptsEditForm}},[(_vm.$store.state.sidebars.showReceiptsEditForm && _vm.$store.state.sidebars.receiptEditData)?_c('receipts-edit-form',{attrs:{"data":_vm.$store.state.sidebars.receiptEditData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }